(() => {
  if (customElements.get('image-slider')) {
    return;
  }

  class ImageSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.options = {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        breakpoints: {
          550: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
          // when window width is >= 480px
          990: {
            slidesPerView: 3,
            spaceBetween: 125,
          },
        },
      };
      if (this.hasAttribute('data-loop')) {
        this.options.loop = true;
      }
      this.slider = new Swiper(
        this,
        this.options
      );
    }
  }

  customElements.define('image-slider', ImageSlider);
})();
